<template>
  <div>
    <b-row v-for="(link, idx) in book.web_shoplinks" class="my-1" :key="'link'+idx">
      <b-col sm="5">
        <b-form-input
          v-model="book.web_shoplinks[idx].link"
          type="text"
          :data-vv-name="'book.web_shoplinks[' + idx + '].link'"
          v-validate="'required'"
          :state="errors.first('book.web_shoplinks[' + idx + '].link')?'invalid':'true'"
          :placeholder="$t('message.ShopLinks.link')"/>
      </b-col>
      <b-col sm="5">
        <b-form-input
          v-model="book.web_shoplinks[idx].label"
          type="text"
          :data-vv-name="'book.web_shoplinks[' + idx + '].label'"
          v-validate="'required'"
          :state="errors.first('book.web_shoplinks[' + idx + '].label')?'invalid':'true'"
          :placeholder="$t('message.ShopLinks.label')"/>
      </b-col>
      <b-col sm="2">
        <b-button @click="addLink">+</b-button>
        <b-button variant="danger" @click="rmLink(idx)">-</b-button>
      </b-col>
    </b-row>

    <template v-if="!book.web_shoplinks || book.web_shoplinks.length==0">
      <b-button @click="addLink" :title="$t('message.ShopLinks.addLink')">+</b-button>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: "ShopLinks",
    inject: ['$validator'],
    props: {
      book: {
        type: Object,
        required: true
      },
      shop_links: {
        type: Array
      },
    },
    methods: {
      addLink() {
        if (this.book.web_shoplinks == undefined) {
          Vue.set(this.book, 'web_shoplinks', [{
            link: null,
            label: null,
          }])
        } else {
          this.book.web_shoplinks.push({
            link: null,
            label: null,
          })
        }
      },

      rmLink(index) {
        this.book.web_shoplinks.splice(index, 1);
      }
    }
  }
</script>

<style scoped>
</style>